// extracted by mini-css-extract-plugin
module.exports = {"holder":"ShareButtonsStyle-module--holder--2xloL","share_text":"ShareButtonsStyle-module--share_text--2JCzd"};